import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b5b701f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"24px","margin-bottom":"24px","margin-left":"10px"} }, " 工商变更已申请内容 ", -1))
const _hoisted_2 = { style: {"padding":"20px","background":"#f9f9f9"} }
const _hoisted_3 = {
  key: 0,
  style: {"margin-bottom":"24px"}
}
const _hoisted_4 = { style: {"color":"#333"} }
const _hoisted_5 = { class: "infomation-seal-content" }
const _hoisted_6 = {
  key: 0,
  class: "item text-overflow"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "地址变更前：", -1))
const _hoisted_8 = {
  key: 1,
  class: "item text-overflow"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "地址变更后：", -1))
const _hoisted_10 = {
  key: 2,
  class: "item text-overflow"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "工商注册地址：", -1))
const _hoisted_12 = { class: "flexBox" }
const _hoisted_13 = { class: "detail-item" }
const _hoisted_14 = {
  key: 0,
  class: "item text-overflow",
  style: {"display":"inline-block"}
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "股权变更前：", -1))
const _hoisted_16 = {
  key: 1,
  class: "item text-overflow",
  style: {"display":"inline-block"}
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "股权变更后：", -1))
const _hoisted_18 = { class: "flexBox" }
const _hoisted_19 = { class: "detail-item" }
const _hoisted_20 = {
  key: 0,
  class: "item text-overflow",
  style: {"display":"inline-block"}
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "名称变更前：", -1))
const _hoisted_22 = {
  key: 1,
  class: "item text-overflow",
  style: {"display":"inline-block"}
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "名称变更后：", -1))
const _hoisted_24 = { class: "flexBox" }
const _hoisted_25 = { class: "detail-item" }
const _hoisted_26 = {
  key: 0,
  class: "item text-overflow",
  style: {"display":"inline-block"}
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "注册资本变更前：", -1))
const _hoisted_28 = {
  key: 1,
  class: "item text-overflow",
  style: {"display":"inline-block"}
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "注册资本变更后：", -1))
const _hoisted_30 = { class: "flexBox" }
const _hoisted_31 = { class: "detail-item" }
const _hoisted_32 = {
  key: 0,
  class: "item text-overflow",
  style: {"display":"inline-block"}
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "营业范围变更前：", -1))
const _hoisted_34 = {
  key: 1,
  class: "item text-overflow",
  style: {"display":"inline-block"}
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "营业范围变更后：", -1))
const _hoisted_36 = { class: "flexBox" }
const _hoisted_37 = { class: "detail-item" }
const _hoisted_38 = {
  key: 0,
  class: "item text-overflow",
  style: {"display":"inline-block","margin-bottom":"0px"}
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "法人、负责人变更前：", -1))
const _hoisted_40 = {
  key: 1,
  class: "item text-overflow",
  style: {"display":"inline-block","margin-bottom":"0px"}
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#666"} }, "法人、负责人变更后：", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"24px","margin-bottom":"24px","margin-left":"10px"} }, " 资料及用印 ", -1))
const _hoisted_43 = { class: "information-seal-applyDetail" }
const _hoisted_44 = { class: "sign-table-wrapper" }

import {
  ref,
  onMounted,
  withDefaults,
  watch,
} from "vue";
import HeadTitle from "@/components/HeadTitle.vue";
import RisTable from "@/components/Table.vue";
import { SEALOPTIONS } from "@/const/home";
import { useRoute } from "vue-router";
import { resourceChangeDetail } from "@/api/change_process";


export default /*#__PURE__*/_defineComponent({
  props: {
    folwId: { default: 0 },
    update: { type: Boolean, default: false },
    traceId: { default: "" }
  },
  emits: ["change-status"],
  setup(__props: any, { emit: $emit }) {

const props = __props as { folwId: number, update: boolean, traceId: string }


const route = useRoute();
const { id } = route.query;


const GsDocumentCollection = ref<string>("");
watch(
  () => props.update,
  (val, oldval) => {
    if (val != oldval) {
      getdata();
    }
  }
);
const tableData = ref<
  { FileName?: string; AccessoryType: number; FileUrl?: string }[]
>([]);
const ChangeMatters = ref<(string | number)[]>([]);
const BusinessRegisteredAddress = ref<string>("");
const addressChangeBefore = ref<string>("");
const addressChangeAfter = ref<string>("");
const shareholdingChangeBefore = ref<string>("");
const shareholdingChangeAfter = ref<string>("");
const nameChangeBefore = ref<string>("");
const nameChangeAfter = ref<string>("");
const registeredCapitalChangeBefore = ref<string>("");
const registeredCapitalChangeAfter = ref<string>("");
const businessScopeChangeBefore = ref<string>("");
const businessScopeChangeAfter = ref<string>("");
const legalPersonChangeBefore = ref<string>("");
const legalPersonChangeAfter = ref<string>("");

onMounted(async () => {
  getdata();
});

const getdata = async () => {
  const { Data } = await resourceChangeDetail({
    Id: id,
    TraceId: props.traceId,
  });
  GsDocumentCollection.value =
    Data?.BusinessChangeApplyDetail?.ChangeMatters.length &&
    Data?.BusinessChangeApplyDetail?.ChangeMatters.map((item: any) => {
      return item.ChangeCode;
    }).join(", ");
  // 1 地址变更，2 股权变更，3 名称变更，4 注册资本变更，5 营业范围变更 6 法人、负责人变更
  ChangeMatters.value = Data?.BusinessChangeApplyDetail?.ChangeMatters;

  ChangeMatters.value.length &&
    ChangeMatters.value.forEach((item: any, index: number) => {
      if (item.ChangeCode === 1) {
        addressChangeBefore.value = ChangeMatters.value[index].ChangeBefore;
        addressChangeAfter.value = ChangeMatters.value[index].ChangeAfter;
      }
      if (item.ChangeCode === 2) {
        shareholdingChangeBefore.value =
          ChangeMatters.value[index].ChangeBefore;
        shareholdingChangeAfter.value = ChangeMatters.value[index].ChangeAfter;
      }
      if (item.ChangeCode === 3) {
        nameChangeBefore.value = ChangeMatters.value[index].ChangeBefore;
        nameChangeAfter.value = ChangeMatters.value[index].ChangeAfter;
      }
      if (item.ChangeCode === 4) {
        registeredCapitalChangeBefore.value =
          ChangeMatters.value[index].ChangeBefore;
        registeredCapitalChangeAfter.value =
          ChangeMatters.value[index].ChangeAfter;
      }
      if (item.ChangeCode === 5) {
        businessScopeChangeBefore.value =
          ChangeMatters.value[index].ChangeBefore;
        businessScopeChangeAfter.value = ChangeMatters.value[index].ChangeAfter;
      }
      if (item.ChangeCode === 6) {
        legalPersonChangeBefore.value = ChangeMatters.value[index].ChangeBefore;
        legalPersonChangeAfter.value = ChangeMatters.value[index].ChangeAfter;
      }
    });

  BusinessRegisteredAddress.value =
    Data?.BusinessChangeApplyDetail?.BusinessRegisteredAddress || "";

  tableData.value = [...(Data?.PageFiles || []), ...(Data?.PostFiles || [])];
  $emit("change-status", {
    buttons: Data?.ActionButtons,
    flowId: Data?.WorkFlowId,
    ApplicationInfo: Data?.ApplicationInfo,
    ApplicationTime: Data?.ApplicationTime,
  });
};

return (_ctx: any,_cache: any) => {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_checkbox_group = _resolveComponent("a-checkbox-group")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeadTitle, {
      title: "变更资料审核",
      style: {"margin-top":"24px"}
    }),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (GsDocumentCollection.value !== '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_a_checkbox_group, {
              disabled: "",
              value: GsDocumentCollection.value.split(',')
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(GsDocumentCollection.value.split(','), (item, index) => {
                  return (_openBlock(), _createBlock(_component_a_checkbox, {
                    key: index,
                    value: item.toString(),
                    label: item
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(SEALOPTIONS)[item - 1]), 1)
                    ]),
                    _: 2
                  }, 1032, ["value", "label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        (addressChangeBefore.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("span", null, _toDisplayString(addressChangeBefore.value), 1)
            ]))
          : _createCommentVNode("", true),
        (addressChangeAfter.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("span", null, _toDisplayString(addressChangeAfter.value), 1)
            ]))
          : _createCommentVNode("", true),
        (BusinessRegisteredAddress.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("span", null, _toDisplayString(BusinessRegisteredAddress.value), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            (shareholdingChangeBefore.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("span", null, _toDisplayString(shareholdingChangeBefore.value), 1)
                ]))
              : _createCommentVNode("", true),
            (shareholdingChangeAfter.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("span", null, _toDisplayString(shareholdingChangeAfter.value), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            (nameChangeBefore.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("span", null, _toDisplayString(nameChangeBefore.value), 1)
                ]))
              : _createCommentVNode("", true),
            (nameChangeAfter.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("span", null, _toDisplayString(nameChangeAfter.value), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            (registeredCapitalChangeBefore.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("span", null, _toDisplayString(registeredCapitalChangeBefore.value), 1)
                ]))
              : _createCommentVNode("", true),
            (registeredCapitalChangeAfter.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("span", null, _toDisplayString(registeredCapitalChangeAfter.value), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            (businessScopeChangeBefore.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("span", null, _toDisplayString(businessScopeChangeBefore.value), 1)
                ]))
              : _createCommentVNode("", true),
            (businessScopeChangeAfter.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("span", null, _toDisplayString(businessScopeChangeAfter.value), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            (legalPersonChangeBefore.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_38, [
                  _hoisted_39,
                  _createElementVNode("span", null, _toDisplayString(legalPersonChangeBefore.value), 1)
                ]))
              : _createCommentVNode("", true),
            (legalPersonChangeAfter.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_40, [
                  _hoisted_41,
                  _createElementVNode("span", null, _toDisplayString(legalPersonChangeAfter.value), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _hoisted_42,
    _createElementVNode("div", _hoisted_43, [
      _createElementVNode("div", _hoisted_44, [
        _createVNode(RisTable, { "table-data": tableData.value }, null, 8, ["table-data"])
      ])
    ])
  ], 64))
}
}

})